import { render, staticRenderFns } from "./config-text-row.vue?vue&type=template&id=38c7b0fb"
import script from "./config-text-row.vue?vue&type=script&lang=js"
export * from "./config-text-row.vue?vue&type=script&lang=js"
import style0 from "./config-text-row.vue?vue&type=style&index=0&id=38c7b0fb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports